// TODO: hooks
import { Outlet, useLocation } from 'react-router-dom'
// NOTE: components
import NavBar from './NavBar'
import ManagerNavBar from './ManagerNavBar'
import { PageErrorBoundaryWrapper } from '../errorBoundary/ErrorBoundary'

interface LayoutProps {
	links: any
	home: string
	icon?: any
	dashboard: string
}

const Layout = ({ links, home, icon, dashboard }: LayoutProps) => {
	const location = useLocation()

	return (
		<div className="flex min-h-screen min-h-svh">
			{dashboard === 'manager' ? (
				<ManagerNavBar links={links} home={home} />
			) : (
				<NavBar links={links} home={home} icon={icon} dashboard={dashboard} />
			)}
			<PageErrorBoundaryWrapper key={location.pathname}>
				<Outlet />
			</PageErrorBoundaryWrapper>
		</div>
	)
}

export default Layout
